import type { Payment } from 'models';
import type { Field } from 'models/field';
import { fetchJson, fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
import type { I18n } from 'utils/translations';

import { isEmpty } from 'lodash';
import { PAYEX_URL } from '../../../constants';
import { translateFields } from './translator';
import type { FetchAcademicParams, SaveAcademicParams } from './types';

export const academic = {
  fetch: async (
    { recipient, required }: FetchAcademicParams,
    { i18n }: { i18n: I18n },
  ) => {
    const path = `${PAYEX_URL}/academic_fields?recipient_id=${recipient}&is_required=${required}`;
    const data = await fetchJson<{ fields?: Field[] }>(path);
    if (!isEmpty(data)) {
      const translatedFields = translateFields(data.fields!, i18n);
      return { fields: translatedFields };
    }

    return { fields: [] };
  },

  save: ({ token, payload }: SaveAcademicParams): Promise<Payment> => {
    const body = JSON.stringify(payload);
    const options = { method: 'POST', body };

    const path = `${PAYEX_URL}/academic_fields?token=${token}`;
    return fetchWithAuthentication(path, options);
  },
};
